/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';

const LoadingSkeleton: React.FC = () => {
    return (
        <div className="bg-gray-900 rounded-xl shadow-sm border border-gray-800 overflow-hidden">
            <table className="w-full">
                <thead className="bg-gray-800 border-b border-gray-700">
                    <tr>
                        <th className="text-left px-6 py-3 text-xs font-medium text-gray-400 uppercase tracking-wider">
                            Name
                        </th>
                        <th className="text-left px-6 py-3 text-xs font-medium text-gray-400 uppercase tracking-wider">
                            Visibility
                        </th>
                        <th className="text-left px-6 py-3 text-xs font-medium text-gray-400 uppercase tracking-wider">
                            Versioning
                        </th>
                        <th className="text-left px-6 py-3 text-xs font-medium text-gray-400 uppercase tracking-wider">
                            Created
                        </th>
                        <th className="text-right px-6 py-3 text-xs font-medium text-gray-400 uppercase tracking-wider">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-700">
                    {[1, 2, 3, 4, 5].map((i) => (
                        <tr key={i}>
                            <td className="px-6 py-4">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-gray-700 rounded-lg animate-pulse"></div>
                                    <div className="space-y-2">
                                        <div className="h-4 w-32 bg-gray-700 rounded animate-pulse"></div>
                                        <div className="h-3 w-20 bg-gray-700 rounded animate-pulse"></div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="h-6 w-16 bg-gray-700 rounded-full animate-pulse"></div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="h-4 w-8 bg-gray-700 rounded animate-pulse"></div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="h-4 w-24 bg-gray-700 rounded animate-pulse"></div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="h-8 w-8 bg-gray-700 rounded-lg animate-pulse ml-auto"></div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default LoadingSkeleton;
